import { deleteRequest, get, publicPost, put } from "../helpers/apihelpers";

export const CreateCaseStageService=async(data)=>{
    try {
        const result = await publicPost(`api/case_stage/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateCaseStageService=async(data,id)=>{
    try {
        const result = await put(`api/case_stage/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetCaseStageService=async(data)=>{
    try {
        const result = await get(`api/case_stage/get`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetCaseStageBasedTypeService=async(id)=>{
    try {
        const result = await get(`api/case_stage/get?id=${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const FilterCaseStageService=async(search='',page=1)=>{
    try {
        const result = await get(`api/case_stage/filter?search=${search}&page=${page}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteCaseStageService=async(id)=>{
    try {
        const result = await deleteRequest(`api/case_stage/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}